export default "__VITE_ASSET__4ee0c949__"